import { Box, Container, Grid, Paper, styled} from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


class Licencias extends Component {
    constructor(props){
        super(props);
        this.state = {

            errores: null,
            notificaciones: null,

            licencia: {
                tipoLicencia: '',
            }
        }
        this.manejarCambioLicencia = this.manejarCambioLicencia.bind(this);
        this.manejoEnvioLicencia = this.manejoEnvioLicencia.bind(this);
    }
    render(){
        return (
            <>
                <Container>
                    <h3>Licencias</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <form className='formulario1'  onSubmit={this.manejoEnvioLicencia}>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoLicencia'  value={this.state.licencia.tipoLicencia} onChange={this.manejarCambioLicencia}>
                                            <option value=''>LICENCIA</option>
                                            <option key={1} value={1}>LICENCIA ESPECIAL 30 AÑOS</option>
                                            {/*<option key={2} value={2}>LIC. REGL. / ACTA 1694</option>*/}
                                            <option key={3} value={3}>ANTIGÜEDAD</option>
                                            <option key={4} value={4}>LIC. REGL. / ANTIGÜEDAD</option>
                                            <option key={5} value={5}>ACTA 1694 / LICENCIA FAMILIAR, ENFERMO / LICENCIA LEY 17.242 / LICENCIA ESTUDIO</option>
                                            {/*<option key={5} value={5}>ACTA 1694</option>
                                            <option key={6} value={6}>LICENCIA FAMILIAR INTERNADO</option>
                                            <option key={7} value={7}>LICENCIA FAMILIAR ENFERMO</option>
                                            <option key={8} value={8}>LICECIA LEY 17.242</option>
                                            <option key={9} value={9}>LICENCIA ESTUDIO</option>*/}
                                        </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Agregar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Container>
            </>
        )//Final Return
    }//Final Render

    manejarCambioLicencia(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const licenciaFunActualizado = state.licencia;
            licenciaFunActualizado[clave] = valor;
            return{
                licencia: licenciaFunActualizado,
            };
        });
    }

    async manejoEnvioLicencia(e){
        e.preventDefault();
        if(this.state.licencia.tipoLicencia === ''){
            this.setState({
                errores: "DEBE SELECCIONAR UN TIPO DE LICENCIA!",
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify([this.state.licencia,'']);

            const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_licencia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito,
            });
            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    modalActualizar: false,
                    errores: null,
                });
            }
        }
    }
}

export default Licencias